import { Language, MessageKey } from "@/i18n";
import { EnabledStatus, ExportFormat } from "@/types";

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/;
export const PASSWORD_MIN_LENGTH = 8;
export const SUPPORT_EMAIL = "support@tournated.com";
export const LIVESCORE_SUPPORT_EMAIL = "livescore@tournated.com";

export const LANGUAGE_NATIVE_LABELS: { [key in Language]: string } = {
  "en-US": "English (US)",
  "en-GB": "English (UK)",
  "de-DE": "Deutsch",
  "el-GR": "Ελληνικά",
  "es-ES": "Español",
  "es-MX": "Español (MX)",
  "et-EE": "Eesti",
  "fr-FR": "Français",
  "hi-IN": "हिन्दी",
  "hr-HR": "Hrvatski",
  "hy-AM": "Հայերեն",
  "it-IT": "Italiano",
  "ja-JP": "日本語",
  "ka-GE": "ქართული",
  "ko-KR": "한국어",
  "lt-LT": "Lietuvių",
  "lv-LV": "Latviešu",
  "pl-PL": "Polski",
  "pt-PT": "Português",
  "ru-RU": "Русский",
  "uk-UA": "Українська",
  "zh-CN": "中文 (简体)",
};

export const ENABLED_STATUS_LABELS: { [key in EnabledStatus]: MessageKey } = {
  enabled: "general.text.enabled",
  disabled: "general.text.disabled",
};

export const EXPORT_FORMAT_LABELS: { [key in ExportFormat]: MessageKey } = {
  excel: "general.enums.exportFormat.excel",
  csv: "general.enums.exportFormat.csv",
  json: "general.enums.exportFormat.json",
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
export const ALLOWED_DOCUMENT_TYPES = ["application/pdf", "image/jpeg", "image/png", "image/webp"];

export const DEFAULT_LIMIT = 25;
